import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import useWindowSize from "helpers/hooks/useWindowSize";
import { Media } from "solar/components/Media";
import VideoAutoPlay from "components/shared/adventures/VideoAutoPlay";
import Text from "components/adventure/Text";
import Title from "components/adventure/Title";
import PhotoCloudfront from "components/shared/adventures/PhotoCloudfront";
import styles from "components/adventure/Guide.module.scss";

export default function Guide({
  guideImage,
  youtubeURL,
  videoLandFirstFrameSrc,
  videoLandMp4 = null,
  videoLandWebm = null,
  title,
  descriptionText,
  buttonText,
}) {
  const windowSize = useWindowSize();
  const breakpointLg = parseInt(styles.solBreakpointLg, 10);
  const [greaterThanLg, setGreaterThanLg] = useState(false);

  useEffect(() => {
    setGreaterThanLg(windowSize.width > breakpointLg);
  }, [windowSize, breakpointLg]);

  // must have either video or guideImage
  return (
    <div className={styles.component}>
      <div className={styles.videoWrapper}>
        {videoLandMp4 && videoLandFirstFrameSrc ? (
          <VideoAutoPlay
            videoLandFirstFrameSrc={videoLandFirstFrameSrc}
            videoLandMp4={videoLandMp4}
            videoLandWebm={videoLandWebm}
            videoAltText={title}
          />
        ) : (
          guideImage && (
            <PhotoCloudfront
              src={guideImage.url}
              fill
              className={styles.photo}
              sizes={[["lg", "100vw"], ["65vw"]]}
            />
          )
        )}
        {youtubeURL && (
          <a
            href={youtubeURL}
            target="_blank"
            rel="noreferrer"
            className={styles.button}
          >
            <span className={styles.buttonText}>{buttonText}</span>
          </a>
        )}
      </div>
      <div className={styles.text}>
        <Media lessThan="lg">
          <Title className={styles.title}>{title}</Title>
        </Media>
        <Media greaterThan="md">
          <Title size="lg" className={styles.title}>
            {title}
          </Title>
        </Media>
        <Text
          maxLength={greaterThanLg ? null : 350}
          className={styles.description}
        >
          {descriptionText}
        </Text>
      </div>
    </div>
  );
}

Guide.propTypes = {
  guideImage: PropTypes.shape({
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  youtubeURL: PropTypes.string,
  title: PropTypes.node.isRequired,
  descriptionText: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  videoLandFirstFrameSrc: PropTypes.string,
  videoLandMp4: PropTypes.string,
  videoLandWebm: PropTypes.string,
};
